import { Navigation } from '@noths/polaris-dev-ts-types';
import { createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';

import { navigationBuilder, productBuilder } from 'src/builders';
import { Product } from 'src/types';
import { requestProductDetails } from './thunks';

export interface ProductState extends Product {
  error: SerializedError | null;
  navigation: Navigation[];
  metaDescription: string;
  quantity: number;
  isQuantityValid: boolean;
  redirectUrl?: string;
}

export const initialState: Readonly<ProductState> = {
  ...productBuilder(),
  error: null,
  metaDescription: '',
  navigation: [navigationBuilder()],
  quantity: 1,
  isQuantityValid: true,
};

export const { actions, reducer } = createSlice({
  name: 'product',
  initialState,
  reducers: {
    changeQuantity: (state, action: PayloadAction<{ quantity: number; isValid: boolean }>) => {
      state.quantity = action.payload.quantity;
      state.isQuantityValid = action.payload.isValid;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestProductDetails.fulfilled, (state, { payload }) => {
        const { product, navigation, metaDescription } = payload;
        return {
          ...initialState,
          ...product,
          navigation,
          metaDescription,
        };
      })
      .addCase(requestProductDetails.rejected, (state, action) => {
        if (action.payload?.redirectUrl) {
          state.redirectUrl = action.payload.redirectUrl;
          return;
        }

        state.error = action.error;
      });
  },
});
